export enum typeMesages {
    ERRO = "erro",
    INTERNO = "interno",
    SISTEMA = "sistema"
}